<!-- <app-header-bar (toggleMenu)="toggleMenu($event)"></app-header-bar> -->
<div class="portal-page-container container-fluid">
  <div class="row">
    <!-- <app-side-menu [isCollapsed]="toggle"></app-side-menu> -->
    <!-- <div class="col portal-page" [@routeAnimation]="outlet.activatedRoute"> -->
    <router-outlet></router-outlet>
    <!-- </div> -->
  </div>
</div>
